import { render, staticRenderFns } from "./EditDownTable.vue?vue&type=template&id=f21e6cda&scoped=true&"
import script from "./EditDownTable.vue?vue&type=script&lang=js&"
export * from "./EditDownTable.vue?vue&type=script&lang=js&"
import style0 from "./EditDownTable.vue?vue&type=style&index=0&id=f21e6cda&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f21e6cda",
  null
  
)

export default component.exports